import { takeEvery } from 'redux-saga/effects';
import { TRANSACTION_INFO_FETCH, TRANSACTION_RECORD_FETCH } from '../constants';
import { transactionRecordSaga, transactionInfoSaga } from './transactionSaga';

export function* rootTransactionSaga() {
  yield takeEvery(TRANSACTION_RECORD_FETCH, transactionRecordSaga);
  yield takeEvery(TRANSACTION_INFO_FETCH, transactionInfoSaga);
}
